import { render, staticRenderFns } from "./EditorAdjustRecords.vue?vue&type=template&id=f5607c5a&scoped=true"
import script from "./EditorAdjustRecords.vue?vue&type=script&lang=js"
export * from "./EditorAdjustRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5607c5a",
  null
  
)

export default component.exports